import { render, staticRenderFns } from "./CCMCarePlanViewDialog.vue?vue&type=template&id=0dffebf7"
import script from "./CCMCarePlanViewDialog.vue?vue&type=script&lang=js"
export * from "./CCMCarePlanViewDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports